import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import langConstant from './langConstant';

const LANGUAGES = {
  en_US: 'en',
  ko_KR: 'ko',
  ja_JP: 'ja',
  zh_CN: 'zh',
  zh_TW: 'tw',
  vi_VN: 'vi',
  fr_FR: 'fr',
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'cookieDetector',
  lookup({ lookupCookie }) {
    const nameEQ = `${lookupCookie}=`;
    const languageCookie = document.cookie
      .split(';')
      .map(c => c.trim())
      .find(c => c.indexOf(nameEQ) === 0);

    if (languageCookie) {
      return LANGUAGES[languageCookie.substring(nameEQ.length, nameEQ.length + 5)];
    }

    return null;
  },
});

languageDetector.addDetector({
  name: 'navigatorDetector',
  lookup() {
    if (navigator.language) {
      return navigator.language;
    }

    return null;
  },
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: langConstant.isKnox ? langConstant.resourcesKnox : langConstant.resourcesBrity,
    debug: true,
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
    },
    detection: { order: ['cookieDetector', 'navigatorDetector'], lookupCookie: 'saveLanguage' },
    fallbackLng: 'en',
    ns: ['contacts'],
  });
export default i18n;
